import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { InputAdornment, MenuItem } from '@mui/material';
import Iconify from '../iconify/iconify';

export default function RHFTextFieldCustomSubMenu({
  name,
  helperText,
  type,
  iconName,
  iconSize,
  optionsMenu = [],
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          error={!!error}
          helperText={error ? error.message : helperText}
          select
          value={field.value || ''} // Assurez-vous que la valeur n'est pas undefined
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon={iconName} width={iconSize} />
              </InputAdornment>
            ),
          }}
          {...other}
        >
          {optionsMenu.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}

RHFTextFieldCustomSubMenu.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  iconName: PropTypes.string,
  iconSize: PropTypes.number,
  optionsMenu: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};
